// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__e9Vnu","horizontalContainer":"gantt_horizontalContainer__uz0Rt","wrapper":"gantt_wrapper__kc0jc"};